import React, { useState } from 'react';
import { URL } from "../../constants/constant";
import SideBar from "../../components/SideBar/SideBar";
import { TextField, MenuItem, Button, Select, FormControl, InputLabel, Snackbar } from "@mui/material";
import "./MasterControl.css";
import axios from 'axios';

const MasterControl = () => {
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [caseId, setCaseId] = useState('');
    const [currentStatus, setCurrentStatus] = useState('');
    const [desiredStatus, setDesiredStatus] = useState('');
    const [duplicateCaseId, setDuplicateCaseId] = useState('');

    const loggedInUser = JSON.parse(localStorage.getItem("loggedInUserDetails"));

    const handleSubmitStatusChange = (event) => {
        event.preventDefault();
        const payload = {
            caseId: caseId,
            currentStatus: currentStatus,
            desiredStatus: desiredStatus,
            user: loggedInUser.emailId
        }
        const response = axios.post(URL.demystify_url + 'basicCaseData/UpdateDemystifyStatus/', payload)
            .then(response => {
                if (response.status !== 200) {
                    setSnackbarMessage('Unable to Modify the status');
                    setSnackbarOpen(true);
                } else {
                    setSnackbarMessage('Status Modified Successfully.');
                    setSnackbarOpen(true);
                }
            })
            .catch(error => {
                setSnackbarMessage('Error: ' + (JSON.stringify(error.response)));
                setSnackbarOpen(true);
            });
    };

    const handleMarkDuplicate = (event) => {
        event.preventDefault();
        const payload = {
            caseId: duplicateCaseId,
            user: loggedInUser.emailId
        }
        const response = axios.delete(URL.demystify_url + 'markDuplicateCase', { data: payload })
            .then(response => {
                if (response.status !== 200) {
                    setSnackbarMessage('Unable to Mark the case as Duplicate');
                    setSnackbarOpen(true);
                } else {
                    setSnackbarMessage('Case Marked as Duplicate Successfully.');
                    setSnackbarOpen(true);
                }
            })
            .catch(error => {
                setSnackbarMessage('Error: ' + (JSON.stringify(error.response)));
                setSnackbarOpen(true);
            });
    };

    return (
        <div className='grid-container-master-control'>
            <div className='grid-sidebar'>
                <SideBar isTechTeam={loggedInUser.isTechTeam} />
            </div>
            <div className='grid-master-control'>
                <div className="master-control-title">
                    <h1>Demystify Master Control Tool</h1>
                </div>
                <form className='master-control-subsection' onSubmit={handleSubmitStatusChange}>
                    <div className='master-control-subtitle'>
                        <h2>Demystify Status Change</h2>
                    </div>
                    <div className='master-control-div'>
                    <TextField
                        label="Case ID"
                        type="number"
                        value={caseId}
                        onChange={(e) => setCaseId(e.target.value)}
                        required
                        className='master-control-field'
                    />
                    </div>
                    <div className='master-control-div'>
                    <FormControl fullWidth className='master-control-field'>
                        <InputLabel>Current Status</InputLabel>
                        <Select
                            value={currentStatus}
                            label="Current Status"
                            onChange={(e) => setCurrentStatus(e.target.value)}
                            required
                        >
                            <MenuItem value="Data Entry Pending">Data Entry Pending</MenuItem>
                            <MenuItem value="Doctor Entry Pending">Doctor Entry Pending</MenuItem>
                            <MenuItem value="QC Pending">QC Pending</MenuItem>
                            <MenuItem value="INCOMPLETE">INCOMPLETE</MenuItem>
                            <MenuItem value="VERIFIED">VERIFIED</MenuItem>
                        </Select>
                    </FormControl>
                    </div>
                    <div className='master-control-div'>
                    <FormControl fullWidth className='master-control-field'>
                        <InputLabel>Desired Status</InputLabel>
                        <Select
                            value={desiredStatus}
                            label="Desired Status"
                            onChange={(e) => setDesiredStatus(e.target.value)}
                            required
                        >
                            <MenuItem value="Data Entry Pending">Data Entry Pending</MenuItem>
                            <MenuItem value="Doctor Entry Pending">Doctor Entry Pending</MenuItem>
                            <MenuItem value="QC Pending">QC Pending</MenuItem>
                            <MenuItem value="INCOMPLETE">INCOMPLETE</MenuItem>
                            <MenuItem value="VERIFIED">VERIFIED</MenuItem>
                        </Select>
                    </FormControl>
                    </div>
                    <Button type="submit" variant="contained">Submit</Button>
                </form>
                <form className='master-control-subsection' onSubmit={handleMarkDuplicate}>
                    <div className='master-control-subtitle'>
                        <h2>Demystify Case Duplication</h2>
                    </div>
                    <div className='master-control-div'>
                    <TextField
                        label="Case ID"
                        type="number"
                        value={duplicateCaseId}
                        onChange={(e) => setDuplicateCaseId(e.target.value)}
                        required
                        className='master-control-field'
                    />
                    </div>
                    <Button type="submit" variant="contained">Mark as Duplicate</Button>
                </form>
                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={() => setSnackbarOpen(false)}
                    message={snackbarMessage}
                />
            </div>
        </div>
    );
};

export default MasterControl;